import * as React from "react";
import { useMemo, useState } from "react";
import { useDndContext } from "@dnd-kit/core";
import DndStylesContext from "./DndStylesContext";
const DndStylesProvider = ({ children }) => {
  var _a;
  const [columnTransform, setColumnTransform] = useState({});
  const dndContext = useDndContext();
  const activeColId = (_a = dndContext.active) == null ? void 0 : _a.id.toString();
  const contextValue = useMemo(
    () => ({
      columnTransform,
      setColumnTransform,
      activeColId
    }),
    [activeColId, columnTransform]
  );
  return /* @__PURE__ */ React.createElement(DndStylesContext.Provider, { value: contextValue }, children);
};
export default DndStylesProvider;
